import React from 'react'
import { Modal } from 'antd'

import SendInvoiceForm from './SendInvoiceForm'
import styles from './send-invoice-modal.module.scss'

const SendInvoiceModal = ({
  title,
  open,
  onClose,
  data,
  isMass = false,
  goToEmailTemplate,
  getEmailTemplate,
  emailTemplateKey,
  getWaTemplate,
  waTemplateKey,
  goToWaTamplate,
  sendEmail,
  transTypeId,
  onConfirmMassSend,
  onPrintPdf,
  withRelationAttachment,
  footerSentVia,
}) => {
  return (
    <Modal
      title={title}
      open={open}
      width={!isMass ? 960 : 600}
      footer={null}
      onCancel={onClose}
      destroyOnHidden
      classNames={{ header: styles.header, body: styles.body }}
      styles={{
        body: {
          height: 'calc(100vh - 200px)',
          overflowY: 'auto',
          overflowX: 'hidden',
          maxWidth: '100%',
        },
      }}
    >
      <div className={styles.bodyContent}>
        <SendInvoiceForm
          data={data}
          isMass={isMass}
          goToEmailTemplate={goToEmailTemplate}
          getEmailTemplate={getEmailTemplate}
          emailTemplateKey={emailTemplateKey}
          getWaTemplate={getWaTemplate}
          waTemplateKey={waTemplateKey}
          goToWaTamplate={goToWaTamplate}
          onClose={onClose}
          sendEmail={sendEmail}
          transTypeId={transTypeId}
          onConfirmMassSend={onConfirmMassSend}
          onPrintPdf={onPrintPdf}
          withRelationAttachment={withRelationAttachment}
          footerSentVia={footerSentVia}
        />
      </div>
    </Modal>
  )
}

export default SendInvoiceModal
